import styled from "styled-components";

interface TextContainerProps {
  $color?: 'primary' | 'secondary';
}

export const TextContainer = styled.div<TextContainerProps>`
  font-weight: 400;
  white-space: break-spaces;
  font-size:0.9rem;
  ${(props) =>
    props.$color &&
    `
      color: ${props.theme.application.scheme[props.$color]};
    `}

  span.bold {
    font-weight: 600;
  }
`;

export const SmallTextContainer = styled.div`
  font-size: 0.8rem;
  font-weight: 400;
  white-space: break-spaces;
  span.bold {
    font-weight: 600;
  }
`;
export const ContentWrapper = styled.div`
  word-break: break-word;
  @media (max-width: 768px) {
    padding-inline-end: 1.2rem;
  }
`;
export const TableContainer = styled.div`
  height: 100%;  
`;
export const UnderlinedTextContainer = styled.div`
  color: ${(props) => props.theme.palette.primary.main};
  text-decoration: underline;
  cursor: pointer;
`;
